import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth } from 'aws-amplify';
export const AuthContext = createContext();

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [isCheckToken, setIsCheckToken] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('sessionToken')) setIsCheckToken(false);
    checkToken();
    //eslint-disable-next-line
  }, []);

  const checkToken = async () => {
    try {
      const current = await Auth.currentSession();
      updateUser();
      localStorage.setItem('sessionToken', current.accessToken.jwtToken);
      setUser(current.idToken.payload);
    } catch (error) {
      console.error(error);
      goToLogin();
    } finally {
      setIsCheckToken(false);
    }
  };

  const loginUser = async (values) => {
    const login = await Auth.signIn(values.username, values.password);
    updateUser();
    const token = login.signInUserSession.accessToken.jwtToken;
    localStorage.setItem('sessionToken', token);
    setUser(login.attributes);
    return user;
  };

  async function updateUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.updateUserAttributes(user, {
        'custom:app': 'Backoffice', //Cliente - Trabajador
      });
    } catch (error) {
      console.error(error);
    }
  }

  const logoutUser = async () => {
    await Auth.signOut();
    goToLogin();
  };

  const goToLogin = () => {
    localStorage.removeItem('sessionToken');
    setUser(null);
    navigate('/auth');
  };

  const contextValue = {
    user,
    loginUser,
    logoutUser,
    sessionToken: localStorage.getItem('sessionToken'),
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {isCheckToken ? 'Revisando Token' : children}
    </AuthContext.Provider>
  );
}
